import { cn } from "@/lib/utils";

interface ToolbarProps {
  children: React.ReactNode;
  color?: string;
}
const Toolbar = ({ children, color = "bg-toolbar" }: ToolbarProps) => (
  <article
    className={cn(
      "flex flex-row justify-center w-full h-15 py-2 touch-device:py-4",
      color,
    )}
  >
    <div className="flex flex-row w-full px-4 large:px-16 touch-device:px-4 max-w-content items-center">
      {children}
    </div>
  </article>
);

export default Toolbar;
